import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import "../../../styles/components/legal/Legal.scss";
import SalvadorCaetanoLogo from "../../../styles/images/SalvadorCaetanoLogo.svg";

let counter;
class TC extends Component {
  constructor(props) {
    super(props);
    counter = 1;
  }

  renderOrderedLists() {
    // Reset for every render so list generation is deterministic after store updates.
    counter = 1;

    return (
      <>
        <ol>{this.renderListItems(11)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_personalDataProcessing_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(14)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_services_goCharge" />
        </h6>
        <ol start={counter}>
          {this.renderListItems(15, [{ amount: 12, style: "a" }])}
        </ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_accessAndMembershipConditions_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(21)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_billingAndPaymentMethods_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(22)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_termsOfServicePricesAndTariffs_goCharge" />
        </h6>
        <ol start={counter}>
          {this.renderListItems(26, [
            { amount: 3, style: "square" },
            { amount: 8, style: "i" },
          ])}
        </ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_evioPlatformOperability_goCharge" />
        </h6>
        <ol start={counter}>
          {this.renderListItems(37, ["", "", "", { amount: 7, style: "a" }])}
        </ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_intellectualPropertyRights_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(40)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_terminationAndCancellation_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(43)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_rightOfWithdrawalInB2CServices_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(47)}</ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_communications_goCharge" />
        </h6>
        <ol start={counter}>
          {this.renderListItems(50, [
            "",
            { amount: 3, style: "a" },
            { amount: 5, style: "a" },
          ])}
        </ol>
        <h6 className="tc-subtitle">
          <Translate value="legalTC_conflictResolution_goCharge" />
        </h6>
        <ol start={counter}>{this.renderListItems(52)}</ol>
      </>
    );
  }

  // uses a global counter to render list items until the specified limit
  renderListItems(limit, children) {
    let list = [];
    let childrenCounter = 0;
    while (counter <= limit) {
      list.push(
        <li>
          {counter === 13 || counter === 14 ? (
            <span>
              <Translate value={`legalTC_point${counter}_1_goCharge`} />
              <b>
                <Translate value={`legalTC_point${counter}_2_goCharge`} />
              </b>
              <Translate value={`legalTC_point${counter}_3_goCharge`} />
            </span>
          ) : (
            <Translate value={`legalTC_point${counter}_goCharge`} />
          )}
          {console.log(I18n.t(`legalTC_point${counter}_goCharge`))}
          {Array.isArray(children) &&
            children.length > 0 &&
            typeof children[childrenCounter] === "object" && (
              <ol
                className={
                  children[childrenCounter].style
                    ? children[childrenCounter].style
                    : "a"
                }
              >
                {this.renderListItemChildren(children[childrenCounter])}
              </ol>
            )}
        </li>
      );
      childrenCounter++;
      counter++;
    }
    return list;
  }

  // renders children for each list item
  renderListItemChildren(children) {
    if (
      children.hasOwnProperty("amount") &&
      Number.isInteger(children.amount)
    ) {
      let childrenListItems = [];
      for (let i = 1; i <= children.amount; i++) {
        childrenListItems.push(
          <li>
            <Translate value={`legalTC_point${counter}_child${i}_goCharge`} />
          </li>
        );
      }
      return childrenListItems;
    }
  }

  render() {
    return (
      <div id="tc">
        {/* Header image */}
        <div className="evio-logo">
          <img src={SalvadorCaetanoLogo} alt="" />
        </div>
        <h4 className="tc-title">
          <Translate value="legal_termsAndConditions_goCharge" />
        </h4>
        {/* Think it looks better if we just make a hyperlink
            instead of having raw urls on the page
        */}
        <div className="tc-text">
          <Translate value="legalTC_text1_goCharge" />
          <a href="https://www.gocharge.pt">https://www.gocharge.pt</a>
          <span>, </span>
          <a href="https://webclient-gocharge.go-evio.com">
            https://webclient-gocharge.go-evio.com
          </a>
          {/* missing a "." at the end of the evio legalTC_text2*/}
          <Translate value="legalTC_text2_goCharge" />
        </div>
        {this.renderOrderedLists()}
        <div className="footer">
          <br />
          <b>
            <Translate value="version_terms_goCharge" /> 1.1
          </b>
          <div>08/05/2023</div>
        </div>
      </div>
    );
  }
}

export default TC;
